import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=71d392b5&"
import script from "./Approval.vue?vue&type=script&lang=js&"
export * from "./Approval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports